import React from 'react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import { messages } from './messages.tsx';

const NEW_ITEM_ORGANIZATION_NAV_MESSAGE_ID = 'new-item-organization-nav-message';
const ItemOrganizationsSpotlight = ({ onAcknowledge }: { onAcknowledge: () => void }) => {
	const { formatMessage } = useIntl();
	return (
		<JiraSpotlight
			actions={[
				{
					onClick: () => onAcknowledge(),
					text: formatMessage(messages.itemOrganizationsSpotlightConfirmButton),
				},
			]}
			heading={formatMessage(messages.itemOrganizationsSpotlightHeading)}
			target="organizations"
			messageType="engagement"
			messageId={NEW_ITEM_ORGANIZATION_NAV_MESSAGE_ID}
			key="organizations"
			dialogPlacement="right top"
			targetRadius={3}
			targetBgColor={token('elevation.surface')}
		>
			{formatMessage(messages.itemOrganizationsSpotlightBody)}
		</JiraSpotlight>
	);
};

export default ItemOrganizationsSpotlight;
